import { render } from "./UpdateStory.vue?vue&type=template&id=cee77d7a"
import script from "./UpdateStory.vue?vue&type=script&lang=js"
export * from "./UpdateStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__